import { render, staticRenderFns } from "./ai-win.vue?vue&type=template&id=e5077730&scoped=true"
import script from "./ai-win.vue?vue&type=script&lang=js"
export * from "./ai-win.vue?vue&type=script&lang=js"
import style0 from "./ai-win.vue?vue&type=style&index=0&id=e5077730&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5077730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5077730')) {
      api.createRecord('e5077730', component.options)
    } else {
      api.reload('e5077730', component.options)
    }
    module.hot.accept("./ai-win.vue?vue&type=template&id=e5077730&scoped=true", function () {
      api.rerender('e5077730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/home/chat/ai-win.vue"
export default component.exports